<template>
  <div class="flex gap-md items-center justify-between w-full p-md pb-sm">
    <div class="text-outline dark:text-outline-dark">
      <div
        class="flex flex-col md:flex-row gap-xs typography-headline-1 md:typography-body-2-semibold cursor-pointer"
        :class="{'text-on-background dark:text-on-background-dark': activeRangeKey === 'from'}"
        @click="$emit('select-range-key', 'from')"
      >
        <or-label>
          {{ $t('HITL.agent-ui.search-sessions.date-range-picker.start-date') }}
        </or-label>
        <span>
          {{ fromLabel }}
        </span>
      </div>
    </div>

    <div>
      {{ $t('HITL.agent-ui.search-sessions.date-range-picker.dash') }}
    </div>

    <div class="flex text-outline dark:text-outline-dark">
      <div
        class="flex flex-col md:flex-row gap-xs typography-headline-1 md:typography-body-2-semibold cursor-pointer"
        :class="{ 'text-on-background dark:text-on-background-dark': activeRangeKey === 'to' }"
        @click="$emit('select-range-key', 'to')"
      >
        <or-label>
          {{ $t('HITL.agent-ui.search-sessions.date-range-picker.end-date') }}
        </or-label>

        <span>
          {{ toLabel }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { OrLabelV3 as OrLabel } from '@onereach/ui-components-25';
import { QueryDateRangeKey } from '../../types';

export default defineComponent({
  name: 'BaseDateTimeRangePickerHeader',
  components: {
    OrLabel,
  },
  props: {
    activeRangeKey: {
      type: String as PropType<QueryDateRangeKey>,
      required: true,
    },
    fromLabel: {
      type: String,
      required: true,
    },
    toLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['select-range-key'],
});
</script>
